import { useState, useEffect } from "react";
import {  useForm, Controller  } from "react-hook-form";
import { Grid, Icon, Divider  } from '@mui/material';
import MDBox from "dashboard/components/MDBox";
import MDButton from "dashboard/components/MDButton";
import MDTypography from "dashboard/components/MDTypography";
import MDInput from "dashboard/components/MDInput";
import MDAlert from "dashboard/components/MDAlert";

const formatter = (number, currency) => {
  const numberFormatter = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: currency || 'USD'
    });
  return numberFormatter.format(number);
}

const CostEstimator = ({userEnter, expression, price, setValue}) => {
  const [items] = useState(userEnter);
  const [errorMsg, setErrorMsg] = useState("");
  const [estimatePrice, setEstimatePrice] = useState(0);
	const [estimatedNum, setEstimatedNum] = useState(0);

  const { register, handleSubmit, control,  formState: { errors } } = useForm({ // setValue,
    /* eslint-disable */
    defaultValues: {
        estimateCalc : items.reduce((acc, item) => {
          acc[item.name] = item.value;
          return acc;
        }, {})
      }
    });

  
  const getNestedErrorPath = (fieldName) => {
    const keys = fieldName.split('.');
    let error = errors[keys[0]];
    if(!error) return ;
    for (const k of keys) {
       if ( k === keys[0] || !error) continue;
       error = error[`${k}`];
    }
    return  error;
  };

  const calculate = variables => {
    try {
      setErrorMsg("");
      // Create an object to store variable values
      const variableValues = {};
  
      // Populate variableValues object with values from the array
      for (const variableName in variables) {
        const variable = variables[variableName];
        variableValues[variableName] = parseFloat(variable) || 0;
      }
      // Extract variable keys and build a dynamic expression
      const variableKeys = Object.keys(variableValues);
      
      // Replace variable names with their values in the expression
      const replacedExpression = expression.replace(
        new RegExp(variableKeys.join("|"), "g"),
        match => variableValues[match] || 0
      );
      // Create a new function that uses variableValues as variables
      const calculateFunction = new Function(
        "variableValues",
        `return (${replacedExpression});`
      );
  
      // Evaluate the expression using the variableValues
      const result = Math.round(calculateFunction(variableValues));
      setEstimatePrice(result * price);
      setEstimatedNum(result);
      setValue('quantity',result);
    } catch (error) {
      setErrorMsg("Erreur de calcul vérifier le nombre de champs et les valeurs initiales");
      return null;
    }
  };

  const onSubmit = data => {
    calculate(data.estimateCalc);
  };

  return (
    <MDBox component="form" sx={{ whiteSpace: "normal" }} role="form" onSubmit={handleSubmit(onSubmit)} noValidate autoComplete="off">
      <Grid container sx={{px:1}} spacing={2} > 
            <Grid xs={12} item>
                <MDTypography variant="h6" color="text" >Champs requis pour le calcul du prix.</MDTypography>
            </Grid>

          {items && items.map((item, index) => {
             const errorPath = getNestedErrorPath(`estimateCalc.${item.name}`);
            return ( 
              <Grid  key={`item-${index}`} xs={6}  sx={{display : Boolean(item.visible === 0) ? "none" : "block" }} lg={4} item >
                <MDBox mb={.3}>
                  <Controller name={`estimateCalc.${item.name}`} control={control}  defaultValue={item.value}
                      render={({ field: { onChange, value } }) => ( 
                        <MDInput 
                          label={item.label}
                          {...register(`estimateCalc.${item.name}`, {  required: item.required ? item.description : false,validate:  item.required ? validationFunctions[item.validation] : ()=>true })}
                          value={value}
                          onChange={onChange}
                          type={item.type}
                          fullWidth
                          error={Boolean(errorPath)}
                          helperText={errorPath?.message}
                          size="small"
                          disabled={Boolean(item.visible === 0)}
                          />
                          )}
                      /> 
                </MDBox>
              </Grid>

            )})}
            <Grid xs={12} item>
            <Divider sx={{width : "100%"}} />
              <MDBox mt={4} mb={1} mr={2} textAlign="right"  sx={{"& .MuiBox-root":{py:1}}} >
                {errorMsg !== "" && <MDAlert color="error" size="small"><small>{errorMsg}</small></MDAlert>}
                <MDTypography variant="h6" sx={{mr : 2}}>Nombre de boites {estimatedNum}</MDTypography>
                <MDTypography variant="h6" sx={{mr : 2}}>{formatter(estimatePrice,"DZD")}</MDTypography>
                <MDButton size="medium" type="submit"  variant="gradient" color="info">
                <Icon fontSize="medium" sx={{mr:1}}>calculate</Icon>
                  Calculer
                </MDButton>
              </MDBox>
            </Grid>
      </Grid>
    </MDBox>
  )
}

export default CostEstimator